/* eslint-disable no-restricted-globals */
import { reportErrorToFaro, scriptUtils } from '@sendible/common';
import SharedStateBridge, { defaultCompose } from '@sendible/shared-state-bridge';
import { EVENTS, publish } from '@sendible/event-manager';
import i18n from '@sendible/frontendv2/src/i18n';
import RTEView from './views/common/RTEView.js';
import FeatureManager from './views/common/FeatureManager.js';
import FeatureTagsManagerView from './FeatureTagsManagerView.js';
import LoginRouter from './loginRouter.js';
import appOnboardingChromeTemplate from '../templates/common/appOnboardingChromeTemplate.html';
import appConciseChromeTemplate from '../templates/common/appConciseChromeTemplate.html';
import appTopBarTemplate from '../templates/common/appTopBarTemplate.html';
import appNavigationTemplate from '../templates/common/appNavigationTemplate.html';

window.linkify = linkify;
window.truncate = truncate;
window.moment = moment;
window.Backbone = Backbone;
window.translate = (key, options = {}) => i18n.t(key, { ns: 'sendible360', ...options });

const initialLoadMethod = {
  themeFolder: 'styles/themes/',
  themeSassFolder: 'images/themes/',
  options: { isConcise: false },
  wizardMode: false,
  isThemed: false,
  isWhiteLabel: false,
  async initialise(options) {
    // Add proxy IP as headers for XHR request
    let proxysrv = document.cookie
      .split('; ')
      .find((row) => row.startsWith('proxysrv'));

    if (proxysrv && proxysrv.length) {
      // eslint-disable-next-line prefer-destructuring
      proxysrv = proxysrv.split('=')[1];
    }

    if (proxysrv && proxysrv !== '') {
      $.ajaxSetup({
        beforeSend(jqXHR, settings) {
          if (
            settings.url.startsWith(
              window.appConfig && window.appConfig.api_url ? window.appConfig.api_url : window.api_url,
            )
          ) {
            jqXHR.setRequestHeader('X-proxysrv', proxysrv);
          }
        },
      });
    }

    if (options) this.options = options;

    if (this.options.isConcise) {
      this.themeFolder = '../styles/themes/';
      $('html').css({ overflow: 'hidden' });
    }

    this.$head = $('head');
    this.$body = $('body');

    this.fetchSiteInfo();
    this.checkLocalStorage();
    this.preventDropReplacingSite();

    Backbone.once('initialize::process-user-tracking', this.processUserTracking);
  },

  fetchSiteInfo() {
    const urlOveride = window.globalObject.getUrlParameter('site_url');
    const themeName = window.globalObject.getUrlParameter('themeName');
    const urlAccessToken = window.globalObject.getUrlParameter('accesstoken');
    const userId = window.globalObject.getUrlParameter('userid');
    let url = `${window.location.protocol}//${window.location.host}`.toLowerCase();

    if (urlAccessToken) {
      this.setActiveAccount(urlAccessToken, userId);
    }

    // check if site_url exists and overide url if it does
    if (urlOveride) {
      url = urlOveride;
    }

    this.domain_url = url;
    this.themeParam = themeName;

    const isNotWhiteLabel = url.indexOf('wlapp') === -1;
    const isSendibleUrl = (
      url.indexOf(WEBPACK_APP) !== -1
      || url.indexOf('future.sendible.com') !== -1
    );

    if (isNotWhiteLabel && isSendibleUrl) {
      this.$body.removeClass('themed');
      this.continueInitialise();
    } else {
      // NOTE: added this line for testing the getSiteInfo will return whitelabel
      // information when you pass this url "http://whitelabelWEBPACK_API";
      Sendible.Connect.getSiteInfo(
        '',
        url,
        (siteinfo) => {
          this.continueInitialise(siteinfo);
        },
        () => {
          this.continueInitialise({ is_wl: false });
        },
      );
    }
  },

  continueInitialise(siteInfo) {
    const accessCookie = this.getActiveAccount();
    const toRegex = Backbone.Router.prototype._routeToRegExp;
    let hashFragment = null;
    let protocol;
    let arEndpoint;

    this.siteInfo = false;

    if (siteInfo && (siteInfo.is_wl === true || siteInfo.ignore === false)) {
      if (this.themeParam) {
        siteInfo.theme_name = this.themeParam;
      }

      if (siteInfo.theme_name == '') {
        siteInfo.theme_name = 'smoothness';
      }

      this.checkAndApplyOverides(siteInfo);

      this.siteInfo = siteInfo;

      this.siteInfo.html_widget_code = this.siteInfo.html_widget_code.replace(
        /&quot;/g,
        '"',
      );
      this.siteInfo.html_widget_code = this.siteInfo.html_widget_code.replace(
        /&amp;quot;/g,
        '"',
      );

      // if the widget code is from overide then the property html_widget_code will contain valid code retrieved from the
      // cache (widget code cache is set from the code validation form in WL settings).
      // Otherwise pass the code thru textarea to convert from html entities to valid code
      if (
        !this.siteInfo.htmlWidgetValidationMode
        && this.siteInfo.html_widget_code
        && $.trim(this.siteInfo.html_widget_code) !== ''
      ) {
        this.siteInfo.html_widget_code = $('<textarea />')
          .html(this.siteInfo.html_widget_code)
          .text();
      }

      arEndpoint = this.siteInfo.api_endpoint.split('//');
      base_api_url = arEndpoint[1];
      protocol = window.location.protocol;

      if (
        base_api_url === WEBPACK_API
        || protocol.indexOf('https') !== -1
      ) {
        window.api_url = `https://${base_api_url}`;
      } else {
        window.api_url = `http://${base_api_url}`;
      }
    }

    this.setAppConfigGlobal();
    this.setBranding();

    if (!this.options.isConcise) {
      this.setGATrackingCode();
      this.setCustomMenus();
    }

    if (!window.pendo || this.options.isConcise) {
      window.appConfig.enablePendo = false;
    }

    // Start backbone history
    Backbone.history.start();

    // get the url fragment
    hashFragment = Backbone.history.getFragment();
    const { pathname } = Backbone.history.location;

    // process existing URL fragments
    if (hashFragment.match(/[?&]path=([^?&]+)/gi) !== null) {
      advancedLocalStorage.setItem(
        's_initialFragment',
        /[?&]path=([^?&]+)/gi.exec(hashFragment)[1],
      );
    } else if (
      hashFragment === ''
      && (
        pathname === ''
        || pathname === '/'
      )
    ) {
      Backbone.history.navigate('#publish', { trigger: true, replace: true });
    }

    if (/manage\/extendtrial/.test(hashFragment)) {
      advancedLocalStorage.setItem('s_initialFragment', hashFragment, 1);
    }

    // emulate backbones routes once off
    if (/auth\/success\/([a-zA-Z0-9]+)/.test(hashFragment)) {
      this.verifyUserAccessToken(
        /auth\/success\/([a-zA-Z0-9]+)/gi.exec(hashFragment)[1],
        true,
      );
      return;
    }

    if (toRegex('auth/error/:token').test(hashFragment)) {
      this.loadLoginPage();
      return;
    }

    // if access token cookie is set, run api call to check user is authentic
    if (typeof accessCookie === 'string' && accessCookie.length > 0) {
      this.verifyUserAccessToken(accessCookie);
    } else {
      this.loadLoginPage(this.options.isConcise);
    }
  },

  preventDropReplacingSite() {
    window.addEventListener(
      'dragover',
      (e) => {
        // eslint-disable-next-line
        e = e || event
        e.preventDefault();
      },
      false,
    );
    window.addEventListener(
      'drop',
      (e) => {
        // eslint-disable-next-line
        e = e || event
        e.preventDefault();
      },
      false,
    );
  },

  setActiveAccount(token, user_id) {
    advancedLocalStorage.setItem('activeAccountCookie', user_id, 1);
    advancedLocalStorage.setItem(`s_accessToken_${user_id}`, token, 1);
  },

  getActiveAccount() {
    const activeAccountCookie = storageUtils.getCookieOrLocalStorageItem(
      'activeAccountCookie',
    );

    if (
      typeof activeAccountCookie === 'number'
      || (
        typeof activeAccountCookie === 'string'
        && activeAccountCookie.length > 0
      )
    ) {
      return storageUtils.getCookieOrLocalStorageItem(
        `s_accessToken_${activeAccountCookie}`,
      );
    }

    return null;
  },

  checkAndApplyOverides(siteInfo) {
    const { href } = location;
    let cache;
    let widget;

    // if theme overide querystring param is present then set on siteInfo
    if (href.indexOf('themeOveride=') !== -1) {
      siteInfo.theme_name = href.substr(href.indexOf('themeOveride=') + 13);
      siteInfo.themeIsOveride = true;
    }

    // if theme overide querystring param is present then set on siteInfo
    if (href.indexOf('htmlWidgetOveride=') !== -1) {
      cache = new Cache();

      widget = cache.read('html_widget_code');

      widget = widget.value || widget;

      siteInfo.html_widget_code = widget;
      siteInfo.htmlWidgetValidationMode = true;
    }
  },

  checkLocalStorage() {
    const testKey = 'test';
    const storage = window.localStorage;

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
    } catch (error) {
      reportErrorToFaro(error, 'appInitialise initialLoadMethod');

      window.globalObject.flags.localStorageAvailable = false;
    }
  },

  setHtmlWidget() {
    const code = this.siteInfo.html_widget_code;

    if (code && code !== '') {
      this.fixHTMLWidget(code, (widgetCode) => {
        this.$body.append(widgetCode);

        if (this.siteInfo.htmlWidgetValidationMode) {
          this.handleWidgetValidation();
        }

        Backbone.trigger('initialize::process-user-tracking');
      });
    }
  },

  async handleWidgetValidation() {
    const checkInterval = 500;
    const elementId = 'calendarView';
    const successNotificationText = window.lookup(`
      Your widget code is validated to avoid issues with your white label.
      Contact us if the widget isn't displayed after saving.
      This window will close now.
    `);
    const timesToCheckforElement = 60;

    const elementExists = await Utils.checkElementExistence(
      elementId,
      timesToCheckforElement,
      checkInterval,
    );

    if (elementExists) {
      Utils.notify(successNotificationText, 'info', null, false);
      new Cache().store('widget-worked', 'true');
      setTimeout(() => {
        window.close();
      }, 3000);
    } else {
      new Cache().store('widget-worked', 'false');
      window.close();
    }
  },

  loadScript(url, type) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.type = type;
      script.onload = () => resolve();
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  },

  fixHTMLWidget(code, callback) {
    const matchScriptTag = /<script.*?<\/script>/g;
    const trimmedCode = code.replace(/\s+/g, ' ');
    const scriptTags = trimmedCode.match(matchScriptTag);

    if (!scriptTags) {
      callback(trimmedCode);
      return null;
    }

    const codeWithout = trimmedCode;

    if (scriptTags.length > 0) {
      Promise.all(
        scriptTags.map((matchedScript) => {
          const urlMatch = matchedScript.match(/src=["'](.*?)["']/);

          if (urlMatch) {
            return this.loadScript(urlMatch[1], matchedScript.includes('module') ? 'module' : 'text/javascript');
          }

          return Promise.resolve(true);
        }),
      ).then(() => {
        callback(codeWithout);
      });
    } else {
      callback(codeWithout);
    }
  },

  async setGATrackingCode() {
    let code;

    if (this.siteInfo && this.siteInfo.ga_tracking_code) {
      code = this.siteInfo.ga_tracking_code;

      if ($.trim(code) !== '') {
        window.ga.l = 1 * new Date();
        await scriptUtils.addScript('//www.google-analytics.com/analytics.js', { async: true });
        window.ga('create', code, 'auto');
      }
    }
  },

  setCustomMenus() {
    if (!this.siteInfo) {
      window.appConfig.customMenus = false;
      return;
    }

    const { menus } = this.siteInfo;

    window.appConfig.customMenus = false;

    if (menus && menus !== '') {
      try {
        window.appConfig.customMenus = JSON.parse(menus);
      } catch (e) {
        reportErrorToFaro(e, 'appInitialise setCustomMenus');

        return;
      }

      window.appConfig.customMenus = _.map(window.appConfig.customMenus, (el) => {
        el.name = $.trim(el.name);
        return el;
      });
    }

    if (window.appConfig.customMenus && window.appConfig.customMenus.length == 0) {
      window.appConfig.customMenus = false;
    }
  },

  loadLoginPage(isConcise) {
    const that = this;

    if (sessionStorage.getItem(window.appConfig.LOGIN_AUTH_TOKEN)) {
      this.verifyUserAccessToken(
        sessionStorage.getItem(window.appConfig.LOGIN_AUTH_TOKEN),
        true,
      );
      sessionStorage.removeItem(window.appConfig.LOGIN_AUTH_TOKEN);
    } else {
      // initialise the login router passing in option
      let extendedLang;
      // set body ID so login specific styles can be set
      that.$body.attr({ id: 'login-page' });

      if (that.siteInfo) {
        // if it's a WL and has extended language then load language
        if (
          that.siteInfo.is_wl
          && that.siteInfo.language
          && that.siteInfo.language.indexOf('_') !== -1
        ) {
          extendedLang = that.siteInfo.language;
        }
      }

      if (isConcise) {
        $('html').addClass('is-bookmarklet');
        this.$body.addClass('concise');
      }

      // run the login router
      // eslint-disable-next-line
      const loginRouter = new LoginRouter({
        isConcise,
        loadLanguage: extendedLang,
      });

      // reload the URL so loginRouter can route accordingly
      Backbone.history.loadUrl();
    }
  },

  verifyUserAccessToken(token, setCookie) {
    Sendible.Connect.profileTokenTest(
      token,
      (data) => {
        const redirectRegex = new RegExp(/login\/redirect\//g);
        const redirectUriRegex = new RegExp(/login\/redirect\/(.+)\//g);
        const redirect = Backbone.history.fragment.match(redirectRegex);
        let redirectUri;

        if (redirect !== null) {
          redirectUri = redirectUriRegex.exec(Backbone.history.fragment);

          if (typeof redirectUri[1] !== 'undefined') {
            redirectUri = decodeURIComponent(redirectUri[1]);

            if (redirectUri.match(/\?/g) === null) {
              window.location = `${redirectUri}?access_token=${token}&username=${data.login}`;
            } else {
              window.location = `${redirectUri}&access_token=${token}&username=${data.login}`;
            }
          }
        }

        if (setCookie) {
          advancedLocalStorage.setItem('activeAccountCookie', data.id);
          advancedLocalStorage.setItem(`s_accessToken_${data.id}`, token);

          // set navigation to default
          Backbone.history.navigate('');
        }

        // this will set the current user properties;
        data.accessToken = token;

        // set login context
        loginContext.init(
          data,
          async () => {
            // this needs to be a global, hence no 'var' declaration
            window.js_featurMngr = new FeatureManager();
            js_featurMngr.setPlanFeaturesInfo(data.feature_restrictions);

            permissionsManager.initialize();
            window.js_featureTagsManager = new FeatureTagsManagerView();

            Utils.setWeekStartOnDateLibrary(loginContext.getWeekStartDay());

            window.js_featureTagsManager.setFeatureTagsFromServer(() => {
              SharedStateBridge.setItem({
                compose: defaultCompose,
                user: {
                  accessToken: data.accessToken,
                  userId: data.id,
                  username: data.login,
                  email: data.email,
                  language: data.language,
                  timezone: data.timezone,
                  featureTags: window.js_featureTagsManager.getAllFeatureTags(),
                  isWhiteLabel: data.is_white_label,
                  canNavigate: permissionsManager.canNavigate.navigation,
                  isSwitchedUser: !loginContext.isLoggedInUserActive(),
                  weekStart: loginContext.getWeekStartDay(),
                },
                app: {
                  addThreadsPromptOpenMode: null,
                  addTikTokPromptOpenMode: null,
                  addingServiceId: null,
                  blueskyConnectionModal: {
                    isConnectOpen: false,
                    reconnectionAccountId: null,
                  },
                  mediaPreview: {
                    isMediaPreviewOpen: false,
                    mediaList: [],
                    initialMediaIndex: 0,
                  },
                },
              });
              this.continueLogin(data);
            });
          },
        );

        const { user_id } = loginContext.getDefaultLoginDetails();

        window.ga('set', 'userId', user_id);
      },
      () => {
        // load the login router
        this.loadLoginPage(this.options.isConcise);
      },
    );
  },

  async continueLogin(data) {
    const domain_url = `${location.protocol}//${location.hostname}`;
    let pathName;
    const self = this;

    this.includeHubspot = false;
    this.whitLabelhasOlarkWidget = false;
    this.appNavigationTemplate = _.template(appNavigationTemplate);

    // global init depends on the $currentuser being populated hence the
    // need to put it here
    window.globalObject.init();
    Utils.init();

    if (
      this.siteInfo
      && this.siteInfo.html_widget_code.indexOf('olark') !== -1
    ) {
      this.whitLabelhasOlarkWidget = true;
    }

    // if whitelabel on sendible env
    if (
      !permissionsManager.isWhiteLabel
      && data.is_white_label
      && !self.options.isConcise
    ) {
      Utils.userAlert(
        "Hi, we can see you're a White Label user. We recommend logging into your White Label dashboard as logging in through Sendible as a White Label user will cause issues. For example, profiles you connect when logged in through Sendible will not be set up through your White Label apps and posts sent through those profiles can then display Sendible. Please log out and then log back in again from your White Label login page.",
      );
    }

    if (!permissionsManager.isWhiteLabel) {
      this.includeHubspot = true;
    } else if (
      permissionsManager.isWhiteLabel
      && permissionsManager.checkPermission('view.adminSettings')
    ) {
      // disable olark
      if (this.whitLabelhasOlarkWidget) {
        this.stopHtmlWidget = true;
      }
    }

    const hasConcisePath = (
      location.pathname
      && location.pathname.length
      && location.pathname.indexOf('concise') !== -1
    );

    const hasPathWithValue = (
      location.pathname
      && location.pathname.length
      && location.pathname !== '/'
    );

    // set the baseUrl for tinymce
    if (hasConcisePath) {
      pathName = location.pathname.substr(
        0,
        location.pathname.indexOf('/concise'),
      );
      window.tinyMCE.baseURL = `${domain_url + pathName}/libs/tinymce`;
    } else if (hasPathWithValue) {
      pathName = location.pathname;
      pathName = pathName.charAt(pathName.length - 1) == '/'
        ? pathName.substr(0, pathName.length - 1)
        : pathName;
      window.tinyMCE.baseURL = `${domain_url + pathName}/libs/tinymce`; // trailing slash important
    } else {
      window.tinyMCE.baseURL = `${domain_url}/libs/tinymce`;
    }

    if (this.options.isConcise) {
      this.AppRouterModule = await import('./appRouterConcise.js');
    } else {
      this.AppRouterModule = await import('./appRouter.js');
    }

    // Populate HTML body with the required chrome elements
    if (!this.options.isConcise) {
      this.primeEditor();
      this.setHtmlWidget();

      this.$body.find('#top-control-bar').html(_.template(appTopBarTemplate)());
      this.$body.find('#top-bar').html(this.appNavigationTemplate());

      Backbone.on('render:top-bar', () => {
        this.$body
          .find('#top-control-bar')
          .html(_.template(appTopBarTemplate)());
      });

      this.showLoading();

      Backbone.once('userstats-populated', _.bind(this.addHubspot, this));
    } else if (this.options.isOnboarding) {
      this.$body.html(_.template(appOnboardingChromeTemplate));
      this.showLoading();
      Backbone.trigger('dom-update');
    } else if (this.options.isConcise) {
      this.$body.html(_.template(appConciseChromeTemplate, { iframeSrc: `https://${WEBPACK_APP}/editor` }));
      this.showLoading();
      Backbone.trigger('dom-update');
    }

    // load the App
    const AppRouter = this.AppRouterModule.default;
    const appRouter = new AppRouter({ showWizard: self.wizardMode });
    const initialFragment = storageUtils.getCookieOrLocalStorageItem(
      's_initialFragment',
    );
    let permissionsPass = false;

    permissionsPass = permissionsManager.checkAccount(appRouter);

    if (permissionsPass) {
      if (typeof initialFragment === 'string' && initialFragment.match('#')) {
        appRouter.navigate(initialFragment, { trigger: true, replace: true });
      } else if (typeof initialFragment === 'string' && !initialFragment.match('#')) {
        publish(EVENTS.CHANGE_PAGE, initialFragment);
      } else if (
        // reload the URL so App.router can route accordingly
        $current_user.hasOwnProperty('app_datetime_moment_readonly')
          && $current_user.app_datetime_moment_readonly === true
      ) {
        Backbone.history.loadUrl();
      } else if (
        // reload the URL so App.router can route accordingly
        ($current_user.hasOwnProperty('app_datetime_moment_readonly')
              && $current_user.app_datetime_moment_readonly === true)
            || self.appRouterToLoad == './appRouterConcise.js'
      ) {
        Backbone.history.loadUrl();
      } else {
        Backbone.once('app-datetime-moment-built', () => {
          setTimeout(() => {
            Backbone.history.loadUrl();
          }, 2000);
        });
      }
    }

    advancedLocalStorage.removeItem('s_initialFragment');
  },

  primeEditor() {
    const self = this;

    this.editorView = new RTEView({
      selector: 'hiddenTinymcePrimer',
      parent: this,
      maxEditorHeight: '300',
    });

    setTimeout(() => {
      self.editorView.cleanup();
      $('#hiddenTinymcePrimerHolder').remove();
    }, 7000);
  },

  addHubspot() {
    if (this.includeHubspot) {
      const hubspotScript = document.createElement('script');
      hubspotScript.id = 'hs-script-loader';
      hubspotScript.type = 'text/javascript';
      hubspotScript.async = true;
      hubspotScript.src = `//js.hs-scripts.com/${HUBSPOT_APP_ID}.js`;
    }
  },

  showLoading() {
    $('.introLoader').addClass('intro-fade');

    if (this.isThemed) {
      setTimeout(() => {
        $('.sLogo').addClass('intro-fade');
      }, 500);
    }

    // if in wizard mode dont hide logo
    if (!this.wizardMode) {
      $('.sLogo').addClass('spinLoader');
      this.delayHideLoading();
    } else {
      this.$body.removeClass('hideLoadingGif');
    }
  },

  delayHideLoading() {
    const $bdrop = $('.modal-backdrop');

    if (!this.options.isConcise) {
      setTimeout(() => {
        $bdrop.fadeOut(1000, () => {
          this.$body.removeClass('hideLoadingGif');
        });
      }, 2000);
    }
  },

  delayShowingContent() {
    setTimeout(() => {
      this.$body.removeClass('stylesNotLoaded');
    }, 2500);
  },

  /*
    The global window.appConfig will be set with one of the themes specified
    in the config.js ('sendible' or 'smoothness') file.
  */
  setAppConfigGlobal() {
    // Use siteInfo to set set window.appConfig accordingly
    let tempThemes;

    if (this.siteInfo) {
      this.isThemed = true;

      tempThemes = this.siteInfo.themes;
      tempThemes.sendible = window.globalObject_allAppConfigThemes.sendible;
      window.globalObject_allAppConfigThemes = tempThemes;
      window.globalObject_allAppConfigThemes = this.sortAZ(window.globalObject_allAppConfigThemes);

      window.appConfig = _.extend(
        window.appConfig.themes.base,
        window.globalObject_allAppConfigThemes[this.siteInfo.theme_name],
      );

      if (this.siteInfo.is_wl) {
        this.isWhiteLabel = true;
        window.appConfig.isWhiteLabel = true;
        this.$body.addClass('white-label');
      }

      if (this.siteInfo.language) {
        window.appConfig.language = this.siteInfo.language;
      }

      window.appConfig.title = this.siteInfo.site_name;
      window.appConfig.base_api_url = base_api_url;
      window.appConfig.api_url = window.api_url;
      window.appConfig.payment_url = window.api_url;
      window.appConfig.supportUrl = this.siteInfo.contact_us_url;
      window.appConfig.widgetsUrl = this.siteInfo.widgets_url;

      if (!window.appConfig.branding) {
        window.appConfig.branding = {
          themeurl: 'smoothness',
        };
      }

      window.appConfig.branding.appTitle = this.siteInfo.site_name;
      window.appConfig.branding.favIcon = this.siteInfo.favicon_url;
      window.appConfig.branding.logo_url = this.siteInfo.logo_url;
      window.appConfig.branding.icon = this.siteInfo.logo_url;
      window.appConfig.branding.avatarDefaultUrl = this.siteInfo.logo_url;
      window.appConfig.branding.contact_us_url = this.siteInfo.contact_us_url;

      if (
        this.siteInfo.signup == 1
        && this.siteInfo.signup_key
        && this.siteInfo.signup_key !== ''
      ) {
        window.appConfig.signup_key = this.siteInfo.signup_key;
        window.appConfig.signup_trial_length = this.siteInfo.signup_trial_length;
      }
    } else {
      window.appConfig = _.extend(
        window.appConfig.themes.base,
        window.globalObject_allAppConfigThemes.sendible,
      );
      window.appConfig.api_url = window.api_url;
    }

    const currentProtocol = window.location.protocol;

    this.domain_url = currentProtocol
      + this.domain_url.substr(this.domain_url.indexOf('://') + 1);

    window.appConfig.domain_url = this.domain_url;

    import('./libs/googleAuth/sendibleGoogleAuth.js');
  },

  sortAZ(obj) {
    const sortedObj = {};
    const temp = [];
    let theme;

    _.each(obj, (el, key) => {
      el.friendlyName = el.friendlyName || key;
      el.indexName = key;

      temp.push(el);
    });

    const len = temp.length;

    temp.sort((a, b) => {
      if (a.friendlyName.toLowerCase() < b.friendlyName.toLowerCase()) return -1;
      if (a.friendlyName.toLowerCase() > b.friendlyName.toLowerCase()) return 1;

      return 0;
    });

    for (let i = 0; i < len; i++) {
      theme = temp[i];

      sortedObj[theme.indexName] = theme;
    }

    return sortedObj;
  },

  setBranding() {
    this.applyTheme(window.appConfig.branding);
    this.applyTitle(window.appConfig.branding);
    this.applyFavicon(window.appConfig.branding);
  },

  /**
   * the following methods enable the themes to be applied by
   * setting title, theme styles, favicon etc.
   */
  applyFavicon(brandingInfo) {
    if (brandingInfo.favIcon != null) {
      const link = document.createElement('link');

      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = brandingInfo.favIcon;

      document.getElementsByTagName('head')[0].appendChild(link);
    }

    // set icons for apple devices
    this.$head.append(
      `<link rel="apple-touch-icon-precomposed" sizes="144x144" href="${this.themeSassFolder}${brandingInfo.themeurl}/images/144x144.png">`
        + `<link rel="apple-touch-icon-precomposed" sizes="114x114" href="${this.themeSassFolder}${brandingInfo.themeurl}/images/114x114.png">`
        + `<link rel="apple-touch-icon-precomposed" sizes="72x72" href="${this.themeSassFolder}${brandingInfo.themeurl}/images/72x72.png">`
        + `<link rel="apple-touch-icon-precomposed" sizes="57x57" href="${this.themeSassFolder}${brandingInfo.themeurl}/images/57x57.png">`,
    );
  },

  applyTitle(brandingInfo) {
    if (brandingInfo.appTitle) {
      document.title = brandingInfo.appTitle;
      window.globalObject.documentTitle = document.title;
    }
  },

  applyTheme(brandingInfo) {
    if (this.siteInfo && this.siteInfo.stylesheet_url) {
      if (this.siteInfo.themeIsOveride) {
        this.applyPreviewOverides();
      } else {
        this.$head.prepend(
          `<link rel="stylesheet"  type="text/css" href="${window.appConfig.api_url}${this.siteInfo.stylesheet_url}" />`,
        );
      }
    }

    if (brandingInfo.themeurl) {
      this.$head.prepend(
        `<link rel="stylesheet"  type="text/css" href="/${this.themeFolder}${brandingInfo.themeurl}/library.css?v=${WEBPACK_CACHEBUSTER}" />`
          + `<link rel="stylesheet"  type="text/css" href="/${this.themeFolder}${brandingInfo.themeurl}/styles.css?v=${WEBPACK_CACHEBUSTER}" />`,
      );

      if ($('html').hasClass('ie8')) {
        this.$head
          .find('link')
          .eq(0)
          .attr(
            'href',
            this.$head
              .find('link')
              .eq(0)
              .attr('href')
              .replace(`?v=${WEBPACK_CACHEBUSTER}`, ''),
          );
        this.$head
          .find('link')
          .eq(1)
          .attr(
            'href',
            this.$head
              .find('link')
              .eq(1)
              .attr('href')
              .replace(`?v=${WEBPACK_CACHEBUSTER}`, ''),
          );
      }
    }

    this.delayShowingContent();
  },

  applyPreviewOverides() {
    let custom_css;
    let parsed_css;

    if (window.localStorage) {
      custom_css = storageUtils.getCookieOrLocalStorageItem('custom_css');

      if (custom_css) {
        try {
          parsed_css = JSON.parse(custom_css);
          this.$head.prepend(`<style>${parsed_css.value}</style>`);
        } catch (err) {
          reportErrorToFaro(err, 'appInitialise applyPreviewOverides');

          console.log('ERROR IN APPINITIALIZE', err);
        }
      }
    }
  },

  processUserTracking() {
    const userDetails = loginContext.getDefaultLoginDetails();
    const isDevOrTest = process.env.SENDIBLE_ENV !== 'production';

    if (window.appConfig.enablePendo) {
      try {
        window.pendoUserData = Utils.getPendoUserData(userDetails, isDevOrTest);
        window.pendoAccountData = Utils.getPendoAccountData(userDetails, isDevOrTest);

        window.pendo.initialize({
          visitor: window.pendoUserData,
          account: window.pendoAccountData,
        });
      } catch (err) {
        reportErrorToFaro(err, 'appInitialise processUserTracking');

        console.log('ERROR IN APPINITIALIZE', err);
      }
    }
  },
};

export default initialLoadMethod;
